export default "__VITE_ASSET__BG7kEB7___"